var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgCalendar = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5BEE",
    stroke: "#5C5BEE",
    strokeWidth: 0.125,
    d: "M17.188 3v.063H19.5A1.44 1.44 0 0 1 20.938 4.5v15a1.44 1.44 0 0 1-1.438 1.438h-15A1.44 1.44 0 0 1 3.063 19.5v-15A1.44 1.44 0 0 1 4.5 3.063h2.313V2.25a.688.688 0 1 1 1.375 0v.813h7.625V2.25a.687.687 0 1 1 1.374 0zM19.5 7.563h.063V4.438h-2.375v.812a.687.687 0 1 1-1.375 0v-.812H8.188v.812a.688.688 0 1 1-1.376 0v-.812H4.439v3.125H19.5Zm-6.687 9.312v-1.812h1.813a.813.813 0 1 0 0-1.625h-1.813v-1.813a.813.813 0 1 0-1.625 0v1.813H9.376a.813.813 0 0 0 0 1.625h1.812v1.812a.813.813 0 0 0 1.625 0Z"
  })));
};
const Memo = /*#__PURE__*/memo(SvgCalendar);
export default Memo;